export const renderForMobile = (breakpoints) =>
  !breakpoints.md ||
  Object.keys(breakpoints).length === 0 ||
  typeof window === "undefined";
